// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","container":"_1TOKw","firstQuotesIcon":"_1dKpF","secondQuotesIcon":"_3GWOU","text":"_2fjPv","bubble":"_31QTO"};